import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Reaction, ReactionId, Reactions, ReactionsEnum, Thread, Threads, TimelineItem, TimelineItemType } from "@teammood/timeline";
import { EMOTICON_REACTION_DEFS, EmoticonReaction } from "../../timeline-item/reaction/emoticon-reactions/emoticon-reaction.type";
import { orderBy } from "lodash";
import { ReactionService } from "../../timeline-item/reaction/reaction.service";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TmPipesModule } from "../../../shared/util/pipes/pipes.module";
import { CommonModule } from "@angular/common";
import { ThreadEmoticonReactionsComponent } from "../../timeline-item/reaction/thread-emoticon-reactions/thread-emoticon-reactions.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "thread-reactions",
    templateUrl: "./thread-reactions.component.html",
    styleUrls: ['./thread-reactions.component.scss', './../thread-message/thread-message.component.scss'],
    standalone: true,
    imports: [
        ThreadEmoticonReactionsComponent,
        MatTooltipModule,
        TmPipesModule,
        CommonModule,
        TranslateModule
]
})
export class ThreadReactionsComponent implements OnInit{
    
    REACT_OPTIONS = [...EMOTICON_REACTION_DEFS.values()].filter(reaction => reaction.id !== ReactionsEnum.care);
    private _reactions: EmoticonReaction[] 
    protected currentReaction: EmoticonReaction;
    private _timelineItem: TimelineItem & Threads & Reactions;

    @Input({ required: true }) timelineItem: TimelineItem & Threads & Reactions;
    @Input() thread: Thread;
    @Output() onThreadReactionsUpdated = new EventEmitter<TimelineItem>();

    set reactions(reactions: Reaction[]) {
        if (reactions) {
          this._reactions = orderBy(this.reactionService.mapToEmoticonReactions(reactions), ['count'], ['desc']);
          this.currentReaction = this._reactions.find(reaction => reaction.selected);
        }
    }
    get reactions(): EmoticonReaction[] {
        return this._reactions;
    }
    
    constructor(
        private reactionService: ReactionService
    ) {}

    ngOnInit(): void {
        this.reactions = this.thread.reactions;
    }

    async react(reaction: ReactionId) {
        if (reaction) {
          const updatedItem = await this.reactionService.reactToThread(this.timelineItem.id, this.timelineItem.itemType, this.thread.id, reaction)
          this.onThreadReactionsUpdated.next( updatedItem )
          this.reactions = updatedItem.threads.find(thread => thread.id === this.thread.id).reactions;
        }
      }
}